<h2 class="distributor-compare-cv-job-offer-title">{{ 'CVDeepAnalyzer.pageTitle' | translate }}</h2>

<div class="distributor-compare-cv-job-offer-container">
    <div class="distributor-compare-cv-job-offer-container-left">
        <div class="buttons-list">
            <div class="buttons-list-item">
                <button mat-button color="primary" class="button-distributor button-top-deep-cv" (click)="getanalysisData()" [routerLink]="['/dashboard/company/cv-deep-analyzer']" [ngClass]="{'selected-button': !isInHome()}">
                   <span class="truncate-text">{{ 'CVDeepAnalyzer.actions.home' | translate }}</span>
                </button>
            </div>
            <div class="buttons-list-item" *ngFor="let analysis of list_active_analysis">
                <button mat-button color="primary" class="button-distributor button-top-deep-cv" (click)="viewAnalysis(analysis)" [ngClass]="{'selected-button': !(analysis.id == id_analysis && !isInHome())}">
                    <span class="truncate-text">{{ analysis.name }}</span>
                </button>
                <span [ngClass]="{'selected-text-badge': !(analysis.id == id_analysis && !isInHome())}" (click)="removeAnalysisfromActive(analysis, $event)" class="button-close-badge">&times;</span>
            </div>
        </div>
    </div>
</div>

<div class="analysis-actions" *ngIf="!isInHome()">
    <div class="analysis-actions-item">
        <button mat-button color="primary" [routerLink]="['/dashboard/company/cv-deep-analyzer/CV-drive']" [queryParams]="{ id_analysis: id_analysis }" [ngClass]="{'selected-button': !iscvActivated()}">
            {{ 'CVDeepAnalyzer.actions.configsearch' | translate }}
        </button>
        <button mat-button color="primary" [disabled]="!getselectedAnalysis()?.selected_json?.job_offers?.length" [routerLink]="['/dashboard/company/cv-deep-analyzer/analyzer']" [queryParams]="{ id_analysis: id_analysis }" [ngClass]="{'selected-button': !iscompareCVJobOfferActivated()}">
            {{ 'CVDeepAnalyzer.actions.listResults' | translate }}
        </button>
    </div>
    <div class="analysis-actions-item">
        <mat-form-field appearance="fill" class="language-selector-field" *ngIf="iscvActivated()">
            <mat-label>{{ 'CVDeepAnalyzer.actions.analysisLanguage' | translate }}</mat-label>
            <mat-select [(ngModel)]="selectedLanguage" name="analysisLanguage" [ngModelOptions]="{ standalone: true }">
                <mat-option value="Español">{{ 'common.labels.spanish' | translate }}</mat-option>
                <mat-option value="English">{{ 'common.labels.english' | translate }}</mat-option>
                <mat-option value="Català">{{ 'common.labels.catalan' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>


<div *ngIf="iscvActivated()" class="analysis-history">
    <app-CV-drive (listCVsEvent)="listCVs = $event" (openJobOfferLibraryEvent)="isjobOfferLibraryActivated = true"></app-CV-drive>
</div>

<div class="job-offer-library-container" *ngIf="isjobOfferLibraryActivated">
    <app-job-offer-library (closeJobOfferLibraryEvent)="isjobOfferLibraryActivated = false" (listJobOffersEvent)="setjobOffersfromcomponent($event)"></app-job-offer-library>
</div>

<div *ngIf="iscompareCVJobOfferActivated()" class="analysis-history">    
    <app-analyzer (reinit_cv_list)="listCVs = []; listJobOffers = [];"></app-analyzer> 
</div>


<div class="analysis-history" *ngIf="isInHome()">

    <div class="analysis-history__loading" *ngIf="analysis_loading">
        <img src="assets/spinner.gif" alt="Loading" class="img-small" />
        <span>{{ 'CVDeepAnalyzer.history.loadingAnalyses' | translate }}</span>
    </div>

    <div class="analysis-card-grid" *ngIf="!analysis_loading">
        <div class="selector-container" style="min-height: 323px;">
            <div
                class="selector-container-item"
                (click)="!is_demo_deep_cv && SetAnalysis()"
                [ngClass]="{'disabled-button': is_demo_deep_cv}"
                [attr.aria-disabled]="is_demo_deep_cv"
                [attr.title]="is_demo_deep_cv ? 'Purchase a license to create more analysis' : null"
            >
                <img src="assets/Deep-CV/new-analysis.png" alt="Nuevo análisis" class="img-small">
                <span>{{ 'CVDeepAnalyzer.actions.newAnalysis1' | translate }} <br> {{ 'CVDeepAnalyzer.actions.newAnalysis2' | translate }}</span>
            </div>
            <div
                class="selector-container-item"
                (click)="!is_demo_deep_cv && isjobOfferLibraryActivated = true"
                [ngClass]="{'disabled-button': is_demo_deep_cv}"
                [attr.aria-disabled]="is_demo_deep_cv"
                [attr.title]="is_demo_deep_cv ? 'Purchase a license to create more analysis' : null"
            >
                <img src="assets/Deep-CV/upload-file-white.png" alt="Subir nueva Job Description" class="img-small">
                <span>{{ 'CVDeepAnalyzer.actions.uploadJobDescription1' | translate }} <br> {{ 'CVDeepAnalyzer.actions.uploadJobDescription2' | translate }}</span>
            </div>
        </div>
        <div class="analysis-history__empty" *ngIf="analysis_data.length === 0 && !analysis_loading">
            
            <p style="margin-top: 18px; color: #8f8db8;">
                {{ 'CVDeepAnalyzer.history.emptyState' | translate }}
            </p>
        </div>
        <div class="analysis-card" *ngFor="let analysis of analysis_data" >
            <div class="analysis-card__header">
                <div class="analysis-card__title-block">
                    <span class="analysis-card__date">{{ analysis.created_time | date:'medium' }}</span>

                    <ng-container  *ngIf="editingAnalysisId !== analysis.id; else editAnalysisNameTpl">
                        <div class="analysis-card__title-block-edit">
                            <h4>
                                {{ analysis.name || ( 'CVDeepAnalyzer.history.analysisFallback' | translate:{ id: analysis.id } ) }}
                                
                            </h4>
                            <button color="primary" type="button" class="analysis-card__edit-btn no-hover-button button-transparent" (click)="startEditingAnalysis(analysis)" title="{{ 'common.buttons.edit' | translate }}">
                                <img src="assets/Deep-CV/boton-editar.png" alt="{{ 'common.buttons.edit' | translate }}" class="img-small">
                            </button>
                        </div>
                    </ng-container>
                    <ng-template #editAnalysisNameTpl>
                        <div class="analysis-card__edit-form">
                            <input
                                type="text"
                                class="analysis-card__input"
                                [(ngModel)]="editingAnalysisName"
                                [ngModelOptions]="{ standalone: true }"
                                placeholder="{{ 'CVDeepAnalyzer.history.analysisNamePlaceholder' | translate }}"
                                title="{{ 'CVDeepAnalyzer.history.analysisNamePlaceholder' | translate }}"
                                maxlength="80"
                            />
                            <div class="analysis-card__edit-actions">
                                <button mat-stroked-button color="primary" type="button" class="analysis-card__edit-btn" (click)="saveAnalysisName(analysis)" [disabled]="editingAnalysisSaving">
                                    <span *ngIf="!editingAnalysisSaving">{{ 'common.buttons.save' | translate }}</span>
                                    <span *ngIf="editingAnalysisSaving"><img src="assets/spinner.gif" alt="Saving" class="img-small" /></span>
                                </button>
                                <button mat-button type="button" class="analysis-card__edit-btn" (click)="cancelEditingAnalysis()" [disabled]="editingAnalysisSaving">
                                    {{ 'common.buttons.cancel' | translate }}
                                </button>
                            </div>
                        </div>
                    </ng-template>
                </div>
                <span class="analysis-card__status" [class.analysis-card__status--completed]="analysis.completed && (analysis.selected_json?.job_offers?.length > 0 && analysis.selected_json?.CV?.length > 0)">
                    {{ analysis.completed && (analysis.selected_json?.job_offers?.length > 0 && analysis.selected_json?.CV?.length > 0) ? ('CVDeepAnalyzer.history.completed' | translate) : ('CVDeepAnalyzer.history.inProgress' | translate) }}
                </span>
            </div>

            <div class="analysis-card__joboffers">
                <label>{{ 'CVDeepAnalyzer.history.jobOffersLabel' | translate }}</label>
                <ng-container *ngIf="!jobOfferNameLoading; else jobOfferLoadingTpl">
                    <div class="analysis-card__chips" *ngIf="getJobOfferNames(analysis).length > 0; else jobOfferEmptyTpl">
                        <span class="analysis-chip" *ngFor="let jobOfferName of getJobOfferNames(analysis)">
                            {{ jobOfferName }}
                        </span>
                    </div>
                    <ng-template #jobOfferEmptyTpl>
                        <span class="analysis-card__empty">{{ 'CVDeepAnalyzer.history.noJobOffers' | translate }}</span>
                    </ng-template>
                </ng-container>
                <ng-template #jobOfferLoadingTpl>
                    <div class="analysis-card__loading">
                        <img src="assets/spinner.gif" alt="Loading job offers" class="img-small" />
                        <span>{{ 'CVDeepAnalyzer.history.loadingJobOffers' | translate }}</span>
                    </div>
                </ng-template>
            </div>

            <div class="analysis-card__stats">
                <div class="analysis-card__stat">
                    <span>{{ 'CVDeepAnalyzer.history.stats.cvs' | translate }}</span>
                    <strong>{{ getCVCount(analysis) }}</strong>
                </div>
            </div>

           

            <div class="analysis-card__buttons">
                <button class="button-transparent no-hover-button" (click)="deleteAnalysis(analysis)">
                    <div class="analysis-card__delete-btn-container">
                        <img src="assets/Deep-CV/borrar.png" alt="{{ 'CVDeepAnalyzer.history.deleteAnalysis' | translate }}" class="img-auto-size">
                        <span class="analysis-card__delete-btn">{{ 'CVDeepAnalyzer.history.deleteAnalysis' | translate }}</span>
                    </div>
                </button>
                <button mat-stroked-button color="primary" (click)="viewAnalysis(analysis)" >
                    {{ 'CVDeepAnalyzer.history.viewAnalysis' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>